import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { NgForm } from '@angular/forms';

import { EscolaridadService } from '../../services/escolaridad/escolaridad.service';
import { ProductosService } from 'src/app/services/productos/productos.service';
import { MatrimonioService } from 'src/app/services/matrimonio/matrimonio.service';
import { PrestamosService } from 'src/app/services/prestamos/prestamos.service';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import { PostulacionesService } from 'src/app/services/postulaciones/postulaciones.service';
import { AfiliacionService } from '../../services/afiliacion/afiliacion.service';
import { Usuario } from '../../models/usuario/usuario.model';
import { Hijo } from '../../models/hijo/hijo.model';
import { ConfirmationDialog } from '../confirmation-dialog/confirmation-dialog.component';
import Swal from 'sweetalert2';
import { TextosService } from '../../services/textos/textos.service';
declare const Rut: any;
declare const ageCalculator: any;

@Component({
  selector: 'app-matrimonio',
  templateUrl: '../../pages/matrimonio/matrimonio.component.html',
  styleUrls: ['../../pages/matrimonio/matrimonio.component.css']
})

export class MatrimonioComponent implements OnInit {

  rol: string = localStorage.getItem("rol")
  nombreUsuario: string = localStorage.getItem("nombreUsuario")
  estado: any
  idEjecutivo = localStorage.getItem("idUsuario")
  rutUsuario: any
  totalMaximo: any
  diasDiferencia: any
  tipos: any
  textos: any
  linkTexto: any
  postulantes: any[];
  afiliado: any = { rutAfiliado: '', idAfiliado: '', nombreAfiliado: '', apellidoAfiliado: '' };

  buscador: any =
    {
      rut: '', rut2: '', rutConyuge: '', rutAfiliado: '', idRegion: '', fechaInicio: '', fechaFin: '', itemsPerPage: 5, currentPage: 1, idSolicitud: '',
      estado: ['INGRESADA', 'EN VALIDACION', 'RECHAZADA', 'APROBADA']
    }
  matrimonio: any = {
    rutAfiliado: '', rutConyuge: '', nombres: '', fechaUnion: '', fechaAdopcion: '',
    tipoUnion: '0',
    archivo: [], archivoTest: null, archivoTest2: null, archivoTest3: null, archivoTest4: null, archivoTest5: null, archivoTest6: null
  }

  constructor(private router: Router, public matrimonioService: MatrimonioService, private escolaridadService: EscolaridadService,
    public prestamosService: PrestamosService, private productosService: ProductosService, private dialog: MatDialog,
    private postulacionesService: PostulacionesService, private afiliacionService: AfiliacionService,
    private textosService: TextosService) {

  }

  ngOnInit(): void { this.loadData() }
  loadData() {
    let vm = this

    if (this.rol == 'ROLE_AFILIADO' || this.rol == 'ROLE_JUBILADO') {
      this.afiliado.nombreAfiliado = this.nombreUsuario;
      this.afiliado.rutAfiliado = this.rutUsuario;
      this.afiliado.idAfiliado = this.idEjecutivo;
    }

    this.matrimonioService.traeTipoMatrimonio().then(
      tipo => this.tipos = tipo
    ).catch(error => console.log(error))

    this.productosService.obtieneProductos().then
      (
        productos => productos[7].parametros.map(parametro => {
          console.log('parametro1:', parametro)
          if (parametro.descripcion == 'DIAS_MAXIMOS_DIFERENCIA_FECHA_MATRIMONIO') {
            vm.diasDiferencia = parametro.valor
          }
        })
      )
      .catch(error => console.log(error))

      this.textosService.obtieneTextos()
      .then(textos => {
        vm.textos = textos; // Asigna el resultado del servicio a `this.textos`
        vm.linkTexto = vm.textos.find(item => item.tipoProducto === "MATRIMONIO")?.valor;             
      })
      .catch(error => {
        console.error('Error al obtener los textos:', error);
      });

  }


  buscaRegistroCivil(rutABuscar: any, ubicacion: any) {
    if (Rut(rutABuscar)) {
      let rut = rutABuscar.split('.').join('').split('-')[0]
      console.log(rutABuscar)
      this.traePostulantes(rut, ubicacion)
    }
    else {
      console.log(rutABuscar)
      this.openAlertDialog('El RUT es incorrecto. Favor Revisar', 'btn-danger')
    }
  }

  traePostulantes(rut: any, ubicacion: any) {
    if(this.rol != 'ROLE_AFILIADO' && this.rol != 'ROLE_JUBILADO'){  
      this.validarEstado(rut.split('-')[0] )
    }
    Swal.fire({
      allowOutsideClick: false,
      icon: 'info',
      text: 'Cargando...'
    });
    Swal.showLoading();
    let vm = this
   
    this.prestamosService.traePostulantes(rut).then
      (
        (usuario: Usuario) => {

          if (ubicacion == 3) {
            vm.afiliado.nombreAfiliado = usuario.nombres + ' ' + usuario.apellidoPaterno
            vm.afiliado.rutAfiliado = usuario.rut + "-" + usuario.dv
            vm.afiliado.idAfiliado = usuario.id
          }
          Swal.close();
        }

      ).catch(error => {
        console.log(error)
        Swal.close();
        vm.openAlertDialog('No se han encontrado usuarios con el RUT ingresado. Intente nuevamente.', 'btn-danger')
      })
  }

  validarEstado(rutAfiliado){
    this.afiliacionService.traeSoloAfiliadoSinEstados(rutAfiliado).then
    ( 
        (response: any) => {
            if(response.estadoAfiliado  && (response.estadoAfiliado.toUpperCase() =='PENDIENTE_AFILIACION'
                || response.estadoAfiliado.toUpperCase() =='DESAFILIADO'
                    || response.estadoAfiliado.toUpperCase() =='RECHAZAR_AFILIACION')){
                        console.log(response.estadoAfiliado)
                this.openAlertDialog('El afiliado se encuentra cerrado o en estado pendiente para solicitar beneficios.', 'btn-danger')
                this.router.navigate(['/index'])                 
            }
        }
    )
    .catch
    (
        error => {
        console.log('error :',error);
        }
    ) 
}

  buscarHijo(rutABuscar) {
    let rut = rutABuscar.split('-')[0] + rutABuscar.split('-')[1]
    Swal.fire({
      allowOutsideClick: false,
      icon: 'info',
      text: 'Cargando...'
    });
    Swal.showLoading();
    let vm = this
    if (Rut(rutABuscar)) {

      this.matrimonioService.buscarHijo(rut).then
        (
          (hijo: Hijo) => {

            console.log(hijo)
            vm.matrimonio.nombreConyugue = hijo.nombres
            vm.matrimonio.run = hijo.run


            Swal.close();
          }

        ).catch(error => {
          console.log(error)
          Swal.close();
          vm.openAlertDialog('No se han encontrado usuarios con el RUT ingresado en el registro civil. Intente nuevamente.', 'btn-danger')
          vm.matrimonio.nombres = ''
          vm.matrimonio.run = ''
          vm.matrimonio.fechaUnion = ''
        })
    } else {
      Swal.close();
      this.openAlertDialog('El RUT es incorrecto. Favor Revisar', 'btn-danger')
      vm.matrimonio.nombreConyugue = ''
      vm.matrimonio.run = ''
      vm.matrimonio.fechaUnion = ''
    }
  }



  seleccionaArchivo(event: any, numero: number) {
    if (event.target.files.length > 0) {
      console.log(event.target.files[0].type)

      let vm = this
      let reader = new FileReader()
      this.matrimonio.archivo[numero] = { url: "", archivo: reader.result, extension: event.target.files[0].type, size: event.target.files[0].size }
      reader.readAsDataURL(event.target.files[0])

      reader.onload = function () {
        vm.matrimonio.archivo[numero] = { url: "", archivo: reader.result, extension: event.target.files[0].type, size: event.target.files[0].size }


      }
    }
  }


  solicitar(form: NgForm) {
    var vm = this
    Swal.fire({
      allowOutsideClick: false,
      icon: 'info',
      text: 'Cargando...'
    });
    Swal.showLoading();
    let usuarioId: any
    let fechaUnionNac = new Date(this.matrimonio.fechaUnion + 'T00:00')
    let fechamaxima = new Date()

    if (!vm.matrimonio.archivo[0]) {
      Swal.close();
      this.openAlertDialog('Es obligatorio adjuntar un certificado', 'btn-dark')
      return false
    }

    if (vm.matrimonio.archivo[0].extension != "application/pdf" && vm.matrimonio.archivo[0].extension != "image/jpeg" &&
      vm.matrimonio.archivo[0].extension != "image/png" && vm.matrimonio.archivo[0].extension != "image/jpg") {
      Swal.close();
      this.openAlertDialog('Debe ingresar un archivo de tipo no modificable (PDF, PNG, JPEG, JPG)', 'btn-dark')
      return false
    }

    if (fechaUnionNac > fechamaxima) {
      Swal.close();
      this.openAlertDialog('La fecha de Matrimonio no debe super la fecha actual. Favor revisar.', 'btn-dark')
      return false
    }

    let fechaMatIngresada = new Date(this.matrimonio.fechaUnion + 'T00:00')
    let fechaMinima = new Date()
    fechaMinima.setDate(fechaMinima.getDate() - this.diasDiferencia)

    if ((fechaMatIngresada < fechaMinima || fechaMatIngresada > new Date())) {
      this.openAlertDialog('La Fecha de solicitud supera la vigencia de 180 dias o excede la fecha actual. Favor revisar.', 'btn-dark')
      Swal.close();
      return false
    }


    usuarioId = this.afiliado.idAfiliado;
    let fechaAdopcion = null;
    if (!this.matrimonio.archivo) {
      Swal.close();
      this.openAlertDialog('Debe cargar el certificado como archivo', 'btn-dark')

      return false
    }

    if (!form.valid) {
      Swal.close();
      this.openAlertDialog('Debe ingresar todos los campos obligatorios', 'btn-dark')

      return false
    }

    let fechaUnion = this.matrimonio.fechaUnion.split('-')[2] + '-' +
      this.matrimonio.fechaUnion.split('-')[1] + '-' +
      this.matrimonio.fechaUnion.split('-')[0]



    this.matrimonioService.ingresarMatrimonio(this.matrimonio, fechaUnion, usuarioId, vm.idEjecutivo).then
      (
        response => {
          console.log(response)
          Swal.close();
          vm.openAlertDialog('Se ha ingresado la solicitud correctamente.', 'btn-success')
          vm.limpiarFormulario();
          vm.matrimonio.archivo.bytes = null, vm.matrimonio.archivo.tipo = null
          form.reset()
          return
        }
      )
      .catch
      (error => {

        if (error.status == 402) {
          vm.openAlertDialog('Documento emitido en periodo de carencia.', 'btn-danger')
          Swal.close();
        }else if (error.status == 406) {
          vm.openAlertDialog('El rut del cónyuge ya se encuentra asociado al afiliado.', 'btn-danger')
          Swal.close();
        } else if(error.status == 412){
          vm.openAlertDialog('Beneficio con fecha de evento anterior a la fecha de afiliación.', 'btn-danger')
          Swal.close();
        } else if (error.status == 410) {
          vm.openAlertDialog('El Beneficio solo se puede solicitar cada 5 años.', 'btn-danger')
          Swal.close();
        } /*else {
          vm.openAlertDialog('El sistema no ha podido generar su solicitud.', 'btn-danger')
          Swal.close();
        }*/

      }
      )
  }

  openAlertDialog(mensaje: string, clase: string) {
    this.dialog.open(AlertDialogComponent, {
      data: { message: mensaje, clase: clase, buttonText: { cancel: 'Listo!' }, }
    })
  }

  salir() {
    const dialogRef = this.dialog.open(ConfirmationDialog, {
      data: { message: '¿Esta seguro de salir del formulario?', buttonText: { ok: 'Si', cancel: 'No' } }
    });

    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) { this.router.navigate(['/index']); }
    });
  }


  limpiarFormulario() {
    var vm = this
    vm.matrimonio.nombreConyugue = ''
    vm.matrimonio.rutConyuge = ''
    vm.matrimonio.tipoUnion = 0
    vm.matrimonio.fechaUnion = ''
    vm.matrimonio.archivo = ''
    vm.matrimonio.archivoTest = ''
    vm.afiliado.nombreAfiliado = ''
    vm.afiliado.rutAfiliado = ''
    vm.afiliado.idAfiliado = ''
    vm.buscador.rutAfiliado = ''
  }
}
